import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { EjsDialogBaseComponent } from '../../shared/components/ejs-dialog-base.component';

import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { TranslocoDirective } from '@jsverse/transloco';
import { OrganizationAdminOrganizationsStore } from './organization-admin-organizations.store';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'goatsports-organization-switch-dialog',
  standalone: true,
  imports: [DialogModule, TranslocoDirective, ButtonModule, LoadingSpinnerComponent],
  templateUrl: './organization-switch-dialog.component.html',
  styleUrls: ['./organization-switch-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationSwitchDialogComponent
  extends EjsDialogBaseComponent
  implements OnInit, OnDestroy
{
  readonly store = inject(OrganizationAdminOrganizationsStore);

  override ngOnInit() {
    super.ngOnInit();
    this.store.loadOrganizationsForCurrentAdmin();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onSelect(uid: string | undefined) {
    if (!uid) return;
    this.store.setActiveOrganization(uid);
    this.closeDialog();
  }
}
